import { useEffect, useState } from "react";
import { getTokenExpiry } from "@/lib/auth";

export interface TokenExpiry {
  /** Sekunden bis zum Ablauf, oder `null` wenn unbekannt. Kann negativ werden. */
  secondsLeft: number | null;
  /** Menschenlesbares Label, z.B. "23 min" oder "2h 14min" oder "abgelaufen". */
  label: string;
}

function formatSeconds(s: number): string {
  if (s <= 0) return "abgelaufen";
  if (s < 60) return `${Math.round(s)} sek`;
  const min = Math.floor(s / 60);
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const rest = min % 60;
  return rest > 0 ? `${h}h ${rest}min` : `${h}h`;
}

/**
 * Tick-Hook fuer das Token-Expiry-Display. Refresht alle `tickMs` (Default
 * 5s) und re-liest exp aus Keycloak, damit ein zwischenzeitlicher
 * updateToken-Refresh die Anzeige aktualisiert.
 */
export function useTokenExpiry(tickMs = 5000): TokenExpiry {
  const [now, setNow] = useState(() => Math.floor(Date.now() / 1000));
  useEffect(() => {
    const t = setInterval(() => setNow(Math.floor(Date.now() / 1000)), tickMs);
    return () => clearInterval(t);
  }, [tickMs]);

  const exp = getTokenExpiry();
  if (exp === null) return { secondsLeft: null, label: "" };
  const secondsLeft = exp - now;
  return { secondsLeft, label: formatSeconds(secondsLeft) };
}
